import { render } from "./TheBand.vue?vue&type=template&id=f88ec9ca"
import script from "./TheBand.vue?vue&type=script&lang=js"
export * from "./TheBand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__